module.exports = __webpack_public_path__ + "media/images/flags/CY-5f31b4d868faa0075f21f70630427342.svg";